export interface TeamMember {
  name: string;
  role: string;
  bio: string;
}

export interface Milestone {
  year: string;
  title: string;
  description: string;
}

export interface Testimonial {
  name: string;
  location: string;
  content: string;
  rating: number;
  productName: string;
}

export const aboutInfo = {
  brandName: '久久精品',
  tagline: '品质经久不衰的精选好物平台',
  foundedYear: '2018',
  mission: '久久精品致力于为追求品质生活的消费者，甄选全球范围内经得起时间考验的精品好物。我们相信，真正的品质不在价格标签上，而在每一次使用的愉悦体验中。',
  vision: '成为华人世界最受信赖的品质生活甄选平台，让每一个人都能以合理的价格，拥有经久耐用的好物。',
  story: `久久精品诞生于一个简单的信念：好东西应该被更多人知道和使用。

2018年，一群热爱生活、追求品质的伙伴发现了一个问题——市场上有太多粗制滥造的快消品，而真正用心做出来的好东西，却往往被埋没在琳琅满目的商品海洋中。

于是，久久精品应运而生。我们的名字"久久"寓意"长长久久"，代表我们对品质的执着追求——我们推荐的每一件商品，都必须是经得起时间考验的好物。

从最初的几个人、几件商品，发展到今天涵盖家居、时尚、生活等多个品类的精选平台，久久精品始终坚守着最初的选品标准：严苛的品控、持久的品质、用心的服务。

我们不追求大而全，只追求每一件都值得。`,
  values: [
    {
      icon: 'ri-shield-check-line',
      title: '严苛品控',
      description: '每一件商品都经过原料溯源、工艺审核、设计评估、体验测试四重筛选，确保品质无忧。',
    },
    {
      icon: 'ri-time-line',
      title: '经久耐用',
      description: '我们偏爱那些能陪伴您十年甚至更久的好物，反对快消式的一次性消费理念。',
    },
    {
      icon: 'ri-heart-line',
      title: '用心服务',
      description: '从选购到售后，久久精品团队全程陪伴，让您的每一次购买都安心、放心。',
    },
    {
      icon: 'ri-global-line',
      title: '全球甄选',
      description: '买手团队深入全球优质产地，为您发现那些藏在世界角落的好东西。',
    },
  ],
  team: [
    { name: '林久安', role: '创始人 & CEO', bio: '十五年零售行业经验，前国际买手，深信好产品自己会说话。' },
    { name: '陈品臻', role: '首席选品官', bio: '十年奢侈品行业品控经验，对材质与工艺有着近乎偏执的追求。' },
    { name: '王心怡', role: '设计总监', bio: '曾任职于米兰设计工作室，将东方美学与西方极简完美融合。' },
    { name: '张致远', role: '客户体验官', bio: '服务过数万名品质生活爱好者，深知每一位用户对好物的期待。' },
  ] as TeamMember[],
  milestones: [
    { year: '2018', title: '品牌创立', description: '久久精品正式成立，以"品质经久不衰"为核心理念，开启精选好物之旅。' },
    { year: '2019', title: '品类扩展', description: '从最初的家居品类，扩展至时尚配饰和生活好物，服务更多品质生活爱好者。' },
    { year: '2020', title: '全球供应链', description: '建立覆盖日本、意大利、北欧等地区的全球优质供应链体系。' },
    { year: '2022', title: '百万用户', description: '累计服务用户突破100万，口碑推荐率高达92%。' },
    { year: '2024', title: '品质升级', description: '推出"久久严选"标准，品控流程全面升级至四重筛选体系。' },
    { year: '2026', title: '全新出发', description: '品牌全面焕新，以更丰富的品类和更优质的服务，陪伴每一位用户的美好生活。' },
  ] as Milestone[],
  testimonials: [
    {
      name: '李女士',
      location: '上海',
      content: '在久久精品买的实木餐桌已经用了三年，木纹越来越漂亮，朋友来家里都夸有品味。最打动我的是他们的选品眼光，每一件都很独特。',
      rating: 5,
      productName: '北欧极简实木餐桌',
    },
    {
      name: '王小姐',
      location: '北京',
      content: '我是久久精品的老顾客了。从真丝枕套到羊绒围巾，每一件都没有让我失望过。品质确实和描述的一样好，会一直支持！',
      rating: 5,
      productName: '真丝缎面枕套套装',
    },
    {
      name: '赵先生',
      location: '深圳',
      content: '送给太太的意大利牛皮托特包，她特别喜欢。皮质手感非常好，做工精细。久久精品的包装也很用心，送礼很有面子。',
      rating: 5,
      productName: '意大利手工牛皮托特包',
    },
    {
      name: '刘女士',
      location: '杭州',
      content: '手工陶瓷香薰灯是我在久久精品买过最满意的单品。每天回家第一件事就是打开它，整个房间的氛围都不一样了。',
      rating: 5,
      productName: '手工陶瓷香薰灯',
    },
    {
      name: '陈女士',
      location: '成都',
      content: '久久精品的文章也写得很好，每次看完都有收获。不仅是买东西，更是一种生活方式的启发。慢生活那篇文章我反复读了好几遍。',
      rating: 5,
      productName: '久久精品文章',
    },
  ] as Testimonial[],
  contact: {
    email: 'hello@jiujiuboutique.com',
    phone: '400-888-9999',
    wechat: '久久精品官方',
    address: '上海市静安区南京西路1788号久久精品大厦15层',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};